{
  "SEARCH": {
    "TABS": {
      "ALL": "Tous",
      "CONTACTS": "Contacts",
      "CONVERSATIONS": "Conversations",
      "MESSAGES": "Messages"
    },
    "SECTION": {
      "CONTACTS": "Contacts",
      "CONVERSATIONS": "Conversations",
      "MESSAGES": "Messages"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "Recherche en cours",
    "LOADING_DATA": "Loading",
    "EMPTY_STATE": "Aucun {item} trouvé pour la requête '{query}'",
    "EMPTY_STATE_FULL": "Aucun résultat pour la requête '{query}'",
    "PLACEHOLDER_KEYBINDING": "/ pour cibler",
    "INPUT_PLACEHOLDER": "Tapez 3 caractères ou plus pour lancer la recherche",
    "RECENT_MESSAGES": "Mes messages récemment envoyés",
    "EMPTY_STATE_DEFAULT": "Recherche par identifiant de conversation, e-mail, numéro de téléphone, messages pour de meilleurs résultats de recherche. ",
    "BOT_LABEL": "Bot",
    "READ_MORE": "En savoir plus",
    "WROTE": "a écrit :",
    "FROM": "de",
    "EMAIL": "courriel",
    "EMAIL_SUBJECT": "objet"
  }
}
